import { render } from "./GeoJSONImporter.vue?vue&type=template&id=0117120e&scoped=true"
import script from "./GeoJSONImporter.vue?vue&type=script&lang=js"
export * from "./GeoJSONImporter.vue?vue&type=script&lang=js"

import "./GeoJSONImporter.vue?vue&type=style&index=0&id=0117120e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0117120e"]])

export default __exports__